/** The translator, bound to whatever locale the kiosk is showing. */
import { translator } from '@mgc/i18n'
import type { StringKey } from '@mgc/i18n'
import { useKiosk } from '@/store/kiosk'

export function useT(): (key: StringKey) => string {
  const locale = useKiosk((s) => s.locale)
  return translator(locale)
}

export type { StringKey }

/**
 * A refusal code, in the language the customer is reading.
 *
 * `docs/offline.md` says refusals are named rather than generic, and they are —
 * on the wire. They reached the screen as the raw kebab-case code, so a
 * customer saw `no-shift`. An unmapped code falls back to a sentence rather
 * than to itself, because a code on a kiosk is worse than an apology.
 */
export function useRefusal(): (code: string | null) => string {
  const t = useT()
  return (code) => {
    if (code === null) return t('refusal.unknown')
    const key = `refusal.${code}` as StringKey
    const text = t(key)
    // `translate` returns the key itself when there is no such string.
    return text === key ? t('refusal.unknown') : text
  }
}
